import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import workData from './PostData/workData';
import testimonialsData from './PostData/testimonialsData';
import blogData from './PostData/blogData';

import Header from './Components/Header';
import Footer from './Components/Footer';
// import NoMatch from './Components/NoMatch';
import Home from './Components/Page/Home';
import About from './Components/Page/About';
import LatestWork from './Components/Page/LatestWork';
import Testimonials from './Components/Page/Testimonials';
import Blog from './Components/Page/Blog';
import BlogPostDetail from './Components/Posts/BlogPostDetail';
import Contact from './Components/Page/Contact';

export const WebsiteName = "Wasek Bellah";
export const WebsiteSlogan = "Web Developer";

function App() {
    const blogDetail = blogData.filter(blog => "/blog/" + blog.permalink === window.location.pathname);

    return (
        <Router>
            <Header></Header>

            <Switch>
                <Route path="/about-me">
                    <About></About>
                </Route>

                {workData.length !== 0 && <Route path="/latest-work">
                    <LatestWork></LatestWork>
                </Route>}

                {testimonialsData.length !== 0 && <Route path="/testimonials">
                    <Testimonials></Testimonials>
                </Route>}

                {blogData.length !== 0 && <Route path="/blog/*">
                    {blogDetail.map(blog => <BlogPostDetail blogData={blog} key={blog.id}></BlogPostDetail>)}
                </Route>}

                {blogData.length !== 0 && <Route path="/blog">
                    <Blog></Blog>
                </Route>}

                <Route path="/contact">
                    <Contact></Contact>
                </Route>

                <Route path="/">
                    <Home></Home>
                </Route>

                {/* <Route path="/*">
                    <NoMatch></NoMatch>
                </Route> */}
            </Switch>

            <Footer></Footer>
        </Router>
    );
}

export default App;
